
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import Translations from '@/models/Localization/Translations';
import { TRANSLATIONS_SET_STATE } from '../MutationTypes';
import { TRANSLATIONS_FETCH } from '../ActionTypes';
import TranslationsRequest from '@/models/Localization/TranslationsRequest';
import LocalizationRepository from '@/utils/API/LocalizationRepository';



export interface LocalizationState {
    totalCount: number;
    count: number;
    translations: Translations;
}

const state: LocalizationState = {
  totalCount: 0,
  count: 0,
  translations: new Translations(),
};

const actions: ActionTree<string, { LocalizationModule: LocalizationState }> = {
  [TRANSLATIONS_FETCH]({ commit }, translationsRequest: TranslationsRequest) {
    return new Promise((resolve, reject) => {
      LocalizationRepository.getTranslations(translationsRequest)
        .then((response) => {
          const translationList = response.data.result;
          if (state.translations.length() != 0) {
            translationList.push(...state.translations.getElements());
          }

          // Remove duplicates from transaltionList
          const uniqueTransaltions = Array.from(new Set(translationList.map((translation: { key: string; }) => translation.key)))
            .map((key) => {
              return translationList.find((translation: { key: string; }) => translation.key === key);
            });

          const translations = new Translations(uniqueTransaltions);

          commit(
            TRANSLATIONS_SET_STATE,
            { totalCount: response.data.totalCount, count: response.data.count, translations }
          );

          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });

  },
};

const mutations: MutationTree<LocalizationState> = {
  [TRANSLATIONS_SET_STATE](state, { totalCount, count, translations }:
        { totalCount: number, count: number, translations: Translations }) {

    state.totalCount = totalCount;
    state.count = count;
    state.translations = translations;
  },
};

const getters: GetterTree<LocalizationState, any> = {
};

export const LocalizationModule = {
  state,
  actions,
  getters,
  mutations,
};
